<template>
  <div class="createPlayStep">
    <div class="headReturn">
      <span @click="toSetting"> <i class="iconfont iconicon_fanhui" style="font-size:14px"></i> 返回列表</span>
      <span style="margin: 0 20px">|</span>
      <span class="name">会员券创建</span>
    </div>

    <!-- 表单 -->
    <main class="main" style="margin: 20px">
      <el-form :model="form" ref="form" label-width="120px">
        <el-form-item label="活动名称:">
          <el-input v-model="form.name" maxlength="15" show-word-limit style="width: 720px"></el-input>
        </el-form-item>

        <el-form-item label="添加优惠券:" required>
          <button
            class="addBtn"
            @click.prevent="
              addBlackList = true;
              queryCoupon();
            "
          >
            添加优惠券
          </button>
        </el-form-item>
        <el-form-item
          v-if="ialpolicy.openimgclass == true"
          class="imgclass"
          @mouseover.native="changeActive($event)"
          @mouseout.native="removeActive($event)"
        >
          <el-button class="imgclassbutton" @click="deteleopenimgclass">删除</el-button>
          <div class="imgclassyouhuijuan">
            <span style="margin: 53px 0px 0 -78px; font-size: 16px; color: #333333">￥</span>
            <span
              style="
                margin: 43px 0px 0 -60px;
                font-size: 45px;
                color: #7B61FF;
                font-weight: bold;
              "
              >{{ ialpolicy.discount }}</span
            >
            <span style="margin: 32px 0px 0 27px; font-size: 16px; color: #333333">满</span>
            <span style="margin: 32px 0 0 48px; font-size: 16px; color: #333333">{{ ialpolicy.quota }} 元使用</span>
            <!-- <span
              style="margin: 32px 0px 0 78px; font-size: 16px; color: #333333"
              ></span
            > -->
            <span style="margin: 54px 0px 0 27px; font-size: 13px; color: #666666">优惠券</span>

            <span v-if="discountCouponState == 1" style="margin: 96px 0px 0 -83px; font-size: 13px; color: #999999">领取时间:</span>
            <span style="margin: 96px 0px 0 -25px; font-size: 12px; color: #999999">{{ ialpolicy.beginTime }}</span>
            <span style="margin: 96px 0px 0 46px; font-size: 13px; color: #999999">~</span>
            <span style="margin: 96px 0px 0 60px; font-size: 12px; color: #999999">{{ ialpolicy.endTime }}</span>

            <span v-if="discountCouponState == 2" style="margin: 96px 0px 0 -83px; font-size: 13px; color: #999999">有效期:</span>
            <!-- <span v-if="discountCouponState==1"
              style="margin: 96px 0px 0 -25px; font-size: 12px; color: #999999"
              >{{ ialpolicy.beginTime }}</span
            >
            <span v-if="discountCouponState==1"
              style="margin: 96px 0px 0 46px; font-size: 13px; color: #999999"
              >~</span
            >
            <span v-if="discountCouponState==1"
              style="margin: 96px 0px 0 60px; font-size: 12px; color: #999999"
              >{{ ialpolicy.endTime }}</span
            > -->
            <img src="@/assets/images/discount-coupon.png" style="margin: 10px 0px 0px -112px; position: absolute" />
          </div>
        </el-form-item>

        <el-form-item label="活动时间:" required>
          <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="form.startTime"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              @change="TimeSendTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 120px; font-size: 12px"
              class="time1"
              :clearable="false"
            ></el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="form.endTime"
              type="datetime"
              @change="TimeSendTime"
              :placeholder="'选择日期时间'"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 145px; font-size: 12px"
              class="time2"
              :clearable="true"
            ></el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
          </div>
          <span class="lastTime" style="margin-left: 10px">
            活动持续 <span style="color: #7B61FF">{{ TimeSendTime1 }}</span> 天
            <!-- <span style="color: #7B61FF;">23</span> 小时  -->
          </span>
        </el-form-item>

        <el-form-item label="会员等级:" required>
          <el-checkbox-group v-model="form.checkList" @change="checkListchange">
            <el-checkbox label="-1">全部</el-checkbox>
            <el-checkbox label="0" :disabled="form.checkList == -1">非会员</el-checkbox>
            <el-checkbox :label="levelList[0]" :disabled="form.checkList == -1" v-if="levelList[0]">{{ levelList[0] }}</el-checkbox>
            <el-checkbox :label="levelList[1]" :disabled="form.checkList == -1" v-if="levelList[1]">{{ levelList[1] }}</el-checkbox>
            <el-checkbox :label="levelList[2]" :disabled="form.checkList == -1" v-if="levelList[2]">{{ levelList[2] }}</el-checkbox>
            <el-checkbox :label="levelList[3]" :disabled="form.checkList == -1" v-if="levelList[3]">{{ levelList[3] }}</el-checkbox>
            <el-checkbox :label="levelList[4]" :disabled="form.checkList == -1" v-if="levelList[4]">{{ levelList[4] }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <!-- <el-form-item label="领取限制:" required>
          <span class="elformitemspancolor">首次登陆店铺会员</span>
          <el-input v-model="form.date1" show-word-limit placeholder="请输入" style="width: 80px; margin: 0 10px"></el-input
          ><span class="elformitemspancolor">天可以领取</span>
        </el-form-item> -->
      </el-form>
    </main>

    <!-- 选择优惠卷弹窗 -->
    <el-dialog title="选择优惠券" :visible.sync="addBlackList" customClass="customWidth" style="width: 120%" :before-close="closeaddBlackList">
      <div class="tab-line">
        <div
          class="tab-item"
          @click="hugItemBtn(1)"
          :class="{ active: topSelect == 1 }"
          :style="{
            color: topSelect == 1 ? changeColor : '',
            'border-top': topSelect == 1 ? '2px solid ' + changeColor : '',
          }"
        >
          <div
            v-if="topSelect == 1"
            style="
              position: absolute;
              height: 2px;
              width: 130px;
              background-color: #fff;
              margin-top: 34px;
            "
          ></div>
          {{ messageOne }}
        </div>
        <div
          class="tab-item"
          @click="hugItemBtn(2)"
          :class="{ active: topSelect == 2 }"
          :style="{
            color: topSelect == 2 ? changeColor : '',
            'border-top': topSelect == 2 ? '2px solid ' + changeColor : '',
          }"
        >
          <div
            v-if="topSelect == 2"
            style="
              position: absolute;
              height: 2px;
              width: 130px;
              background-color: #fff;
              margin-top: 34px;
            "
          ></div>
          {{ messageTwo }}
        </div>
      </div>
      <div class="topTis tipBg" v-if="topSelect == 1">
        <img
          src="@/assets/images/new_icon_waring_yellow.png"
          style="
            display: inline-block;
            float: left;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 16px 4px 0 3px;
          "
        />
        <div class="desc">
          <p>
            优惠券类型推荐选择【免费领取】【不公开】【全平台】的优惠券。
            <el-button style="margin: 0 60px; color: #7f85e9" type="text" @click="bordPhone">去创建优惠券></el-button>
          </p>
          <p v-if="venderType" style="color:red">
            抱歉，此类型奖品暂时不支持自营店铺！
          </p>
        </div>
      </div>
      <div class="recharge-box" v-if="topSelect === 1" id="insertPosition">
        <input-form style="margin-top: 20px" :inputData="inputData" :defaultSelectArr="true" @toParentVal="querysearchContent"></input-form>

        <div class="section-right-content-box-table" v-loading="loading" style="margin: 20px">
          <div class="table-box">
            <el-table
              ref="multipleTable"
              :data="recordData"
              tooltip-effect="light"
              :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
              :cell-style="{ 'text-align': 'left' }"
              style="width: 100%; opacity: 1"
              @selection-change="handleSelectionChange"
            >
              <el-table-column prop="name" label="优惠券名称"></el-table-column>
              <el-table-column label="领取时间" width="180">
                <template slot-scope="scope">
                  起:<span>{{ scope.row.takeBeginTime }}</span> 止:<span>{{ scope.row.takeEndTime }}</span>
                </template>
              </el-table-column>
              <el-table-column label="活动时间" width="180">
                <template slot-scope="scope">
                  起:<span>{{ scope.row.beginTime }}</span> 止:<span>{{ scope.row.endTime }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="leftNum" label="剩余量(张)"></el-table-column>
              <el-table-column label="面额/使用条件" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.discount }}</span
                  >元/满 <span>{{ scope.row.quota }}</span
                  >元
                </template></el-table-column
              >
              <el-table-column label="操作" width="50">
                <template slot-scope="scope">
                  <span
                    class="Notetake"
                    @click="
                      preferentialpolicy(scope.row.discount, scope.row.couponId, scope.row.takeBeginTime, scope.row.takeEndTime, scope.row.quota, 1)
                    "
                    >选择</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              style="text-align: right; margin-top: 20px; "
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="recordTotal"
              :current-page="1"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="recharge-box" v-if="topSelect === 2" id="insertPosition">
        <div>
          <div class="alert_box tipBg" style="margin-top: 20px">
            <div class="alert">
              <img
                src="@/assets/images/new_icon_waring_yellow.png"
                style="
                  display: inline-block;
                  float: left;
                  width: 14px;
                  position: absolute;
                  height: 14px;
                  color: #ffffff;
                  margin: 4px 4px 0px -18px;;
                "
              />外部优惠券需手动
              <span slot="reference" style="color: rgb(127, 133, 233); margin-left: 38px; cursor: pointer" @click="sansbordPhone"
                >添加外部优惠券></span
              >
              <p>
                根据平台规定，优惠券不支持直接发放到买家账号，必须通过链接点击领取，请商家明确活动成本预算，防止优惠券链接被恶意分享的风险
              </p>
            </div>
          </div>
          <el-form ref="formSearch" :inline="true" :model="tableForm" label-width="120px" style="margin-top: 20px">
            <el-form-item label="优惠券名称:">
              <el-input size="small" v-model="recordParamsExternal.name" placeholder="请输入优惠券名称" style="margin-right: 40px"></el-input>
            </el-form-item>
            <el-form-item label="优惠券面额:">
              <el-input size="small" v-model="recordParamsExternal.discount" placeholder="请输入买家账号" style="margin-right: 40px"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div style="text-align: center" class="btn">
          <el-button class="share_button1" @click="querySellerCouponExternalClick" style="margin: 0 12px 0px 0">
            <i
              class="el-icon-search"
              style="
                display: inline-block;
                width: 14px;
                height: 12px;
                fontweight: bold;
              "
            ></i>
            查询
          </el-button>
          <el-button size="small" class="share_button2" @click="resetForm" style="margin: 0 auto">重置</el-button>
        </div>

        <div class="table-box" style="margin-top: 20px">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="recordData1"
            tooltip-effect="light"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 100%; opacity: 1"
            @selection-change="handleSelectionChange"
          >
            <el-table-column prop="name" label="优惠券名称"></el-table-column>
            <el-table-column label="领取时间" width="180">
              <template slot-scope="scope">
                起:<span>{{ scope.row.takeBeginTime }}</span> 止:<span>{{ scope.row.takeEndTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="活动时间" width="180">
              <template slot-scope="scope">
                起:<span>{{ scope.row.beginTime }}</span> 止:<span>{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="面额/使用条件">
              <template slot-scope="scope">
                <span>{{ scope.row.discount }}</span
                >元/满<span>{{ scope.row.quota }}</span
                >元
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span
                  class="Notetake"
                  @click="preferentialpolicy(scope.row.discount, scope.row.couponId, scope.row.beginTime, scope.row.endTime, scope.row.quota, 2)"
                  >选择</span
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            style="text-align: right; margin-top: 20px; "
            @size-change="handleSizeChangeOne"
            @current-change="handleCurrentChangeOne"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="recordParamsExternal.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="recordTotalTwo"
            :current-page="recordParamsExternal.current"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <!-- 底部按钮 -->
    <footer class="foot">
      <button class="backBtn" @click="closecreateBenefit">取消</button>
      <button class="keepBtn" v-preventReClick @click="createBenefit(form.name, form.startTime, form.endTime, form.checkList)">
        确定
      </button>
    </footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import { createBenefitActivity } from "@/api/integralCenter/benefitActivityController";
import { querySellerCouponWriteList, querySellerCouponExternalList } from "@/api/integralCenter/couponWriteController";
import inputForm from "../../../components/inputForm";
export default {
  computed: {
    ...mapState({
      // changeColor: "globalBG",
      venderType: "venderType",
    }),
  },
  components: {
    inputForm,
  },
  created() {},
  data() {
    return {
      changeColor: "#7B61FF",
      levelList: [],
      tableForm: {},
      tableTable: [],
      pin: "",
      recordTotal: 0,
      recordTotalTwo: 0,
      total: 0,
      recordParams: {
        //优惠券表格下方
        current: 1,
        size: 10,
        isTake: 1,
        grantType: 3,
        isFilter: true,
        changeActive: true,
        removeActive: true,
        beginTime: "",
        endTime: "",
        display: 1,
        type: 0,
      },
      recordParamsExternal: {
        //优惠券表格下方
        current: 1,
        isTake: 1,
        size: 10,
        discount: "",
        name: "",
      },
      TimeSendTime1: 0,
      inputData: [
        {
          name: "类型:",
          val: "type",
          width: "80px",
          placeholder: "请选择",
          selectArr: [
            { label: "京券", id: 0, defaultValue: 0 },
            { label: "东券", id: 1 },
          ],
        },
        {
          name: "发放类型:",
          val: "grantType",
          placeholder: "请选择",
          selectArr: [
            { label: "促销绑定", id: 1, defaultValue: 3, disabled: true },
            { label: "推送", id: 2, disabled: true },
            { label: "免费领取", id: 3, disabled: false },
            { label: "京豆换券", id: 4, disabled: true },
            { label: "互动平台", id: 5, disabled: true },
          ],
        },
        {
          name: "是否公开:",
          val: "display",
          width: "80px",
          placeholder: "请选择",
          selectArr: [
            { label: "公开", id: 3, defaultValue: 1 },
            { label: "不公开", id: 1 },
          ],
        },
        // {
        //   name: "优惠券名称:",
        //   val: "name",
        //   placeholder: "优惠券名称",
        //   width: 215,
        // },
      ],
      discountCouponState: 0,
      messageOne: "内部优惠券",
      messageTwo: "外部优惠劵",
      addBlackList: false,
      topSelect: 1, //选择优惠卷切换栏
      endTime: "",
      rules: "",
      startTime: "",
      loading: true,
      recordData: [],
      //优惠券数据
      recordData1: [], //外部优惠券表格信息
      ialpolicy: {
        discount: "",
        couponId: "",
        beginTime: "",
        endTime: "",
        start: "",
        end: "",
        quota: "",
        openimgclass: false,
      }, //优惠券信息
      form: {
        name: "会员券",
        number: "",
        startTime: "",
        endTime: "",
        count: "",
        date1: "",
        checkList: ["-1"],
        need: "",
        levelList: {
          not: "",
          one: "",
          two: "",
          three: "",
          four: "",
          five: "",
        },
        rulesText: "",
      },
    };
  },
  mounted() {
    this.getLevel();
  },

  methods: {
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          this.levelList = [];
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    //跳转内部优惠券
    bordPhone() {
      window.open("https://passport.shop.jd.com/login/index.action?ReturnUrl=https%3A%2F%2Fpromo.shop.jd.com%2Fweb%2Fcoupon%2Fdetail%2Fshop%2F0%3F");
    },
    //外部优惠券
    sansbordPhone() {
      this.$router.push({
        path: "../prizeCenter/coupon_management",
        query: { to: 1 },
      });
    },
    //重置
    resetForm() {},
    //切换事件
    hugItemBtn(type) {
      this.topSelect = type;
      if (type == 1) {
        this.showcode = false;
        this.queryCoupon();
      } else {
        this.querySellerCouponExternalClick();
      }
    },
    //清空时间
    clearTimeSendTime() {
      this.form.startTime = "";
      this.form.endTime = "";
      this.TimeSendTime1 = 0;
    },
    //删除优惠券
    deteleopenimgclass() {
      this.ialpolicy.discount = "";
      this.ialpolicy.couponId = "";
      this.ialpolicy.beginTime = "";
      this.ialpolicy.endTime = "";
      this.ialpolicy.start = "";
      this.ialpolicy.end = "";
      this.ialpolicy.quota = "";
      this.ialpolicy.openimgclass = false;
      this.$message.success("删除优惠卷成功");
    },
    //计算时间
    TimeSendTime() {
      const end = Date.parse(new Date(this.form.endTime));
      const now = Date.parse(new Date(this.form.startTime));
      let invalidateDate = new Date(this.$store.getters.pointUserInfo.expiredIn).valueOf();
      let hdInvalidateDate = new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf();
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.form.endTime = null;
        return;
      }
      if (end > hdInvalidateDate) {
        this.$message.warning("活动时间不可超过互动数据授权有效期！");
        this.form.endTime = null;
        return;
      }
      if (this.form.startTime != "" && this.form.endTime != "") {
        if (end < now) {
          this.$message.error("选择时间错误");
          this.clearTimeSendTime();
        } else {
          const msec = end - now;
          let time = parseInt(msec / 1000 / 60 / 60);
          let day = parseInt(msec / 1000 / 60 / 60 / 24);
          if (time < 24) {
            this.TimeSendTime1 = 1;
          } else {
            this.TimeSendTime1 = day;
          }
        }
      }
    },
    //优惠券鼠标移入事件
    changeActive($event) {
      $event.currentTarget.className = "imgclass1 imgclassbutton imgclassyouhuijuan";
    },
    //优惠券鼠标移出事件
    removeActive($event) {
      $event.currentTarget.className = "imgclass imgclassbutton imgclassyouhuijuan";
    },
    handleSelectionChange() {},
    searchContent() {},
    //页码变化
    handleCurrentChange(val) {
      this.recordParams.current = val;
      this.queryCoupon();
    },
    handleSizeChange(val) {
      this.recordParams.size = val;
      this.queryCoupon();
    },
    //内部优惠券页码变化
    handleCurrentChangeOne(val) {
      this.recordParamsExternal.current = val;
      this.querySellerCouponExternal();
    },
    handleSizeChangeOne(val) {
      this.recordParamsExternal.size = val;
      this.querySellerCouponExternal();
    },
    //选择优惠券
    preferentialpolicy(discount, couponId, beginTime, endTime, quota, state) {
      this.ialpolicy.discount = discount;
      this.ialpolicy.couponId = couponId;
      this.ialpolicy.start = beginTime;
      this.ialpolicy.end = endTime;
      this.ialpolicy.couponType = state;
      console.log(state);
      this.discountCouponState = state;
      this.ialpolicy.beginTime = /\d{4}-\d{1,2}-\d{1,2}/g.exec(beginTime)[0];
      this.ialpolicy.endTime = /\d{4}-\d{1,2}-\d{1,2}/g.exec(endTime)[0];
      this.ialpolicy.quota = quota;
      this.ialpolicy.openimgclass = true;
      this.addBlackList = false;
      this.$message.success("选择优惠券成功");
    },
    //取消创建会员权益活动
    closecreateBenefit() {
      this.$emit("returnBack");
      this.$message.warning("已取消会员券创建");
    },
    //创建会员权益活动
    createBenefit(name, startTime, endTime, checkList) {
      if (name == "") {
        this.$message.warning("请输入活动名称");
        return;
      } else if (this.ialpolicy.couponId == "") {
        this.$message.warning("请选择优惠券");
        return;
      } else if (startTime == "" || endTime == "") {
        this.$message.warning("请选择活动时间");
        return;
      } else if (checkList == "") {
        this.$message.warning("请选择会员等级");
        return;
      } else {
        let couponId1 = this.ialpolicy.couponId;
        let checkList1 = checkList.join(",");
        let couponType = this.ialpolicy.couponType;
        let dto = {
          // exceedDays: Number(date),
          activityName: name,
          allowLevel: checkList1,
          couponId: couponId1,
          endTime: endTime,
          startTime: startTime,
          type: 12,
          couponType: couponType,
        };
        createBenefitActivity(dto)
          .then((res) => {
            if (res && res.code == 1) {
              this.$emit("returnBack");
              this.$message.success("添加成功");
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      }
    },
    //关闭优惠券窗口
    closeaddBlackList() {
      this.addBlackList = false;
      this.topSelect = 1;
      this.$message.warning("已取消选择优惠券");
    },
    //选中改变
    checkListchange(val) {
      console.log(val);
      val.forEach((low) => {
        if (low == -1) {
          this.form.checkList = ["-1"];
        }
      });
    },

    //按内部优惠券条件查询查询
    querysearchContent(from) {
      this.recordParams.current = 1;
      this.recordParams.size = 10;
      // this.recordParams.name = from.name;
      this.recordParams.type = from.type;
      this.recordParams.grantType = from.grantType;
      this.recordParams.display = from.display;
      this.queryCoupon();
    },

    //查询内部优惠券信息
    queryCoupon() {
      this.loading = true;
      querySellerCouponWriteList(this.recordParams)
        .then((res) => {
          this.recordData = res.data.records;
          this.recordTotal = Number(res.data.total);
          this.loading = false;
        })
        .catch((res) => {});
    },
    //查询内部优惠卷
    querySellerCouponExternalClick() {
      this.querySellerCouponExternal();
    },
    //查询外部优惠券信息
    querySellerCouponExternal() {
      this.loading = true;
      querySellerCouponExternalList(this.recordParamsExternal)
        .then((res) => {
          this.recordData1 = res.data.records;
          this.recordTotalTwo = Number(res.data.total);
          this.loading = false;
        })
        .catch((res) => {});
    },
    //活动时间变化
    activityTimeChange() {},
    //返回上一页
    toSetting() {
      this.$emit("returnBack");
    },
  },
};
</script>

<style scoped lang="scss">
.createPlayStep {
  min-width: 1160px;
  position: relative;
  box-sizing: border-box;
  min-height: 800px;
  background-color: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin: 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #2e3458;
      font-size: 16px;
      // font-family: PingFang SC;
      font-weight: bold;
      line-height: 22px;
      cursor: default;
    }
  }
  .main {
    flex: 1;
    color: #333333;
    box-sizing: border-box;
    padding: 40px 0 0 70px;

    .imgclass {
      border: 1px solid #eeeeee;
      width: 300px;
      height: 140px;
      position: relative;
      margin-left: 120px;
      margin-bottom: 20px;
      border-radius: 3px;
      opacity: 1;
      .imgclassbutton {
        position: absolute;
        z-index: -1;
        margin: 49px 0 0 -17px;
        width: 98px;
        height: 32px;
        color: #ffffff;
        border-radius: 3px;
        border: 1px solid #7b61ff;
        background-color: #7b61ff;
        opacity: 1;
        &:hover {
          color: #fff;
          opacity: 0.9;
          background-color: #7b61ff;
        }
        &:active {
          color: #7b61ff;
          border: 1px solid #7b61ff;
          background-color: #fff4f4;
        }
      }
      .imgclassyouhuijuan {
        // opacity: 0.2;
        span {
          position: absolute;
          z-index: 1;
        }
      }
    }

    .imgclass1 {
      border: 1px solid #7b61ff;
      width: 300px;
      height: 140px;
      position: relative;
      margin-bottom: 20px;
      margin-left: 120px;
      border-radius: 3px;
      opacity: 1;
      .imgclassbutton {
        position: absolute;
        z-index: 10;
        margin: 49px 0 0 -17px;
        width: 98px;
        height: 32px;
        color: #ffffff;
        border-radius: 3px;
        border: 1px solid #7b61ff;
        background-color: #7b61ff;
        opacity: 1;
        &:hover {
          color: #fff;
          opacity: 0.9;
          background-color: #7b61ff;
        }
        &:active {
          color: #7b61ff;
          border: 1px solid #7b61ff;
          background-color: #fff4f4;
        }
      }
      .imgclassyouhuijuan {
        opacity: 0.2;
        span {
          position: absolute;
          z-index: 1;
        }
      }
    }

    .addBtn {
      width: 98px !important;
      height: 32px;
      line-height: 28px;
      border-radius: 3px;
      border: 1px solid #7b61ff;
      color: #7b61ff;
      &:hover {
        background-color: #7b61ff;
        color: #fff;
      }
    }
    span {
      color: #333333;
      font-size: 14px;
    }
  }
  .customWidth {
    width: 1100px;
  }
  .tab-line {
    font-size: 14px;
    color: #666;
    border-bottom: 1px solid #dddddd;
    margin: 20px 28px 0 28px;
    .tab-item {
      text-align: center;
      width: 130px;
      height: 36px;
      line-height: 36px;
      display: inline-block;
      position: relative;
      cursor: pointer;
      margin-right: 2px;
      border: 1px solid #dddddd;
      border-bottom: none;
      span {
        position: absolute;
        width: 100%;
        left: 50%;
        height: 2px;
        transform: translateX(-50%);
        bottom: -2px;
        display: none;
      }
      &.active {
        border-top: 2px;
        span {
          display: block;
          background: #fff;
        }
      }
    }
  }
  .topTis {
    display: flex;
    align-items: baseline;
    color: #333;
    font-size: 14px;
    background: #fffaee;
    margin: 30px;
    padding: 12px;
    color: #333;
    .desc {
      line-height: 20px;
    }
    p {
      margin-left: 5px;
      line-height: 20px;
    }
  }
  .alert_box {
    margin-left: 20px;
    border-radius: 5px;
    padding: 0;
    background: #fffaee;
    width: 724px;
    opacity: 1;
    margin: 30px;
    font-weight: 400;
    position: relative;

    .alert {
      opacity: 1;
      font-size: 14px;
      color: #333333;
      font-weight: 400;
      line-height: 21px;
      padding: 10px 0 10px 30px;
    }
    .icon_i {
      display: inline-block;
      position: absolute;
      width: 14px;
      height: 14px;
      border-radius: 14px;
      background-color: #fe8f8a;
      color: #fff;
      font-size: 10px;
      text-align: center;
      line-height: 14px;
      font-weight: bold;
      margin: 3px 0 0 -16px;
    }
  }
  .Notetake {
    cursor: pointer;
    color: #7f85e9;
    &:hover {
      color: #7b61ff;
    }
  }
  .section-right-content-box-table {
    .table-box {
      .Notetake {
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #7b61ff;
        }
      }
    }
  }

  .share_button1 {
    width: 98px;
    height: 32px;
    color: #7b61ff;
    border: 1px solid #7b61ff;
    background-color: #fff;
  }
  .share_button1:hover {
    color: #fff;
    background-color: #7b61ff;
  }
  .share_button2 {
    width: 98px;
    height: 32px;
    color: #666666;
    border: 1px solid #dddddd;
    background-color: #fff;
  }
  .share_button2:hover {
    color: #7b61ff;
    background-color: #fff4f4;
    border: 1px solid #7b61ff;
  }
  .foot {
    flex-shrink: 0;
    display: flex;
    width: 100%;
    align-items: center;
    position: absolute;
    bottom: 10px;
    justify-content: center;
    height: 98px;
    border-top: 1px solid #f6f6f6;
    .backBtn {
      margin-right: 20px;
      width: 98px;
      height: 32px;
      color: #666666;
      border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #7b61ff;
        border: 1px solid #7b61ff;
        background: rgba(123, 97, 255, 0.1);
      }
    }
    .keepBtn {
      width: 98px;
      height: 32px;
      border-radius: 3px;
      background-color: #7b61ff;
      color: #fff;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>
